import { Repository } from './Repository';

export default class NcodeEditRepository extends Repository {
    constructor() {
        super();

        this.nCodeEditRequestPrefix = '/api/v1/file';
    }

    getNprojList = (rowsPerPage, page, sortColumn, sortDirection) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/nproj?rowsPerPage=${rowsPerPage}&page=${page}&sortColumn=${sortColumn}&sortDirection=${sortDirection}`);
    };

    addNproj = (param) => {
        return this.getRequestPromise('post', this.nCodeEditRequestPrefix + `/nproj`, param);
    };

    updateNproj = (nprojId, param) => {
        return this.getRequestPromise('put', this.nCodeEditRequestPrefix + `/nproj/${nprojId}`, param);
    };

    removeNproj = (nprojIdList) => {
        return this.getRequestPromise('delete', this.nCodeEditRequestPrefix + `/nproj`, nprojIdList);
    };

    getNprojDownloadUrl = (nprojId) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/nproj/${nprojId}/download`);
    }

    getNcp2List = (rowsPerPage, page) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/ncp?rowsPerPage=${rowsPerPage}&page=${page}`);
    };

    addNcp2 = (param) => {
        return this.getRequestPromise('post', this.nCodeEditRequestPrefix + `/ncp`, param);
    };

    updateNcp2 = (ncpFileId, param) => {
        return this.getRequestPromise('put', this.nCodeEditRequestPrefix + `/ncp/${ncpFileId}`, param);
    };

    removeNcp2 = (ncp2IdList) => {
        return this.getRequestPromise('delete', this.nCodeEditRequestPrefix + `/ncp`, ncp2IdList);
    };

    getNcp2DownloadUrl = (ncp2Id) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/ncp/${ncp2Id}/download`);
    }

    getFirmwareList = (kind, rowsPerPage, page) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/firmware?kind=${kind}&rowsPerPage=${rowsPerPage}&page=${page}`);
    };

    addFirmware = (param) => {
        return this.getRequestPromise('post', this.nCodeEditRequestPrefix + `/firmware`, param);
    };

    removeFirmware = (firmwareFileId, firmwareFileModelId) => {
        return this.getRequestPromise('delete', this.nCodeEditRequestPrefix + `/firmware/${firmwareFileId}/model/${firmwareFileModelId}`);
    };

    getFirmwareDownloadUrl = (firmwareFileId) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/firmware/${firmwareFileId}/download`);
    };

    getRagBookList = (rowsPerPage, page) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/rag-book?rowsPerPage=${rowsPerPage}&page=${page}`);
    };

    addRagBook = (param) => {
        return this.getRequestPromise('post', this.nCodeEditRequestPrefix + `/rag-book`, param);
    };

    updateRagBook = (ragBookId, param) => {
        return this.getRequestPromise('put', this.nCodeEditRequestPrefix + `/rag-book/${ragBookId}`, param);
    };

    removeRagBook = (ragBookIdList) => {
        return this.getRequestPromise('delete', this.nCodeEditRequestPrefix + `/rag-book`, ragBookIdList);
    };

    getRagBookDownloadUrl = (ragBookId) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/rag-book/${ragBookId}/download`);
    };

    getTestRagBook = (param) => {
        return this.getRequestPromise('post', this.nCodeEditRequestPrefix + `/rag-book/test`, param);
    };

    getRagData = (ragBookId) => {
        return this.getRequestPromise('get', this.nCodeEditRequestPrefix + `/rag-book/${ragBookId}/data`);
    };

    addRagData = (ragBookId, param) => {
        return this.getRequestPromise('post', this.nCodeEditRequestPrefix + `/rag-book/${ragBookId}/data`, param);
    };

    updateRagData = (ragBookId, ragDataId, param) => {
        return this.getRequestPromise('put', this.nCodeEditRequestPrefix + `/rag-book/${ragBookId}/data/${ragDataId}`, param);
    };

    removeRagData = (ragBookId, ragDataId) => {
        return this.getRequestPromise('delete', this.nCodeEditRequestPrefix + `/rag-book/${ragBookId}/data/${ragDataId}`);
    };
}
